import styled, { css } from 'styled-components';

export const Content = styled.div`
  position: relative;
`;

export const Place = styled.div`
  position: relative;
  background: #10151a;
  border: 1px solid #2c353d;
  /* border-radius: 10px; */
  /* overflow: hidden; */
`;
export const RectorPlace = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.1);
  z-index: 10;
  ${(props) =>
    props.$active &&
    css`
      z-index: 9999;
    `}

  .ReactFreeSelect__Component {
    position: absolute !important;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }
`;

export const Buttons = styled.div`
  display: flex;
  align-items: flex-start;
  margin: 3px 0px 3px 0;
  flex-wrap: wrap;
  padding: 10px 0;
  .btn {
    margin-right: 20px;
  }

  position: relative;
  &.loading1::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: rgba(14, 21, 24, 0.72);
    z-index: 3;
  }
  &.loading1::before {
    content: '';
    z-index: 11;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: url(/images/loader.svg) no-repeat 50%;
    background-size: 60px auto;
  }
`;

export const Info = styled.div`
  margin: 10px 0 0;
  color: #7a838a;
  font-size: 12px;
`;
